exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sale-point-list[data-v-59ce28a0]{background-color:#f0f0f0;height:100%}.sale-point-list-container[data-v-59ce28a0]{padding:20px;width:100%}", ""]);

// exports
